import React from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import { GcsFileViewer } from './GcsFileViewer';

export const GcsGlobalPage = () => (
  <Page themeId="tool">
    <Header title="GCS Explorer" subtitle="Browse and manage your Google Cloud Storage files">
    </Header>
    <Content>
      <GcsFileViewer />
    </Content>
  </Page>
);